import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { MetricDetailsTab } from 'webapp/enums/enums';

import eq from 'webapp/helpers/eq';

interface Args {
	activeTab: MetricDetailsTab;
	switchTab: (tab: MetricDetailsTab) => void;
}

export default class MetricDetailsTabsComponent extends Component<Args> {
	@service('metric-details') declare metricDetailsService: Service.MetricDetails;

	get tabs() {
		const tabs = [{ value: MetricDetailsTab.EXPLORE, label: 'Explore' }];
		if (this.metricDetailsService.showForecasts) {
			tabs.push({ value: MetricDetailsTab.FORECAST, label: 'Forecast' });
		}
		return tabs;
	}

	get showTabs(): boolean {
		return this.tabs.length > 1;
	}

	@action
	handleTabClick(tab: MetricDetailsTab): void {
		this.args.switchTab(tab);
	}

	<template>
		{{#if this.showTabs}}
			<div class="metric-explorer__tabs">
				{{#each this.tabs as |tab|}}
					<button
						class="metric-explorer__tab
							{{if (eq @activeTab tab.value) 'metric-explorer__tab--active'}}"
						type="button"
						{{on "click" (fn this.handleTabClick tab.value)}}
					>
						{{tab.label}}
					</button>
				{{/each}}
			</div>
		{{/if}}
	</template>
}
